module.exports = __webpack_public_path__ + "static/media/iphone_11_pro_dark.e1c26688.svg";